import axios from 'axios';
import apiConfig from '../api.config';

export default function setCarouselUrlRequest(id, paperlessCarouselUrl) {
  const {
    host,
    URIs: { setCarouselUrl },
  } = apiConfig;

  const uri = `${host}${setCarouselUrl.replace(':hotelId', id)}`;

  return axios
    .post(
      uri,
      { paperlessCarouselUrl },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then(res => res.data);
}
